import { Link } from 'react-router-dom';

const perks = [
  { icon: 'ri-user-heart-line', label: 'Cinsiyet Filtresi' },
  { icon: 'ri-map-pin-line', label: 'Ülke Filtresi' },
  { icon: 'ri-advertisement-line', label: 'Sıfır Reklam' },
  { icon: 'ri-flashlight-line', label: 'Öncelikli Eşleşme' },
  { icon: 'ri-repeat-line', label: 'Yeniden Bağlan' },
  { icon: 'ri-hd-line', label: 'HD Video' },
];

const PremiumFinalCTA = () => {
  return (
    <section className="py-20 md:py-28 bg-[#05070d] relative overflow-hidden">
      {/* BG */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-900/15 via-transparent to-orange-900/10" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[350px] rounded-full bg-yellow-500/8 blur-[100px]" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-500/30 to-transparent" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 md:px-8 text-center">
        {/* Crown icon */}
        <div className="w-20 h-20 flex items-center justify-center rounded-3xl bg-gradient-to-br from-yellow-500/20 to-orange-500/20 border border-yellow-500/30 mx-auto mb-8">
          <i className="ri-vip-crown-line text-yellow-400 text-4xl" />
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-5 leading-tight">
          Sohbet Deneyimini{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
            Dönüştür
          </span>
        </h2>
        <p className="text-white/45 text-base md:text-lg mb-10 max-w-xl mx-auto leading-relaxed">
          Premium'a geç, filtreleri aç, reklamları kapat. İlk haftayı beğenmezsen para iadesi garantisi.
        </p>

        {/* Perks */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
          {perks.map((p) => (
            <div
              key={p.label}
              className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-white/60 text-sm"
            >
              <i className={`${p.icon} text-yellow-400 text-sm`} />
              {p.label}
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <Link
            to="/auth?mode=register"
            className="group inline-flex items-center gap-3 px-10 py-4 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 text-black font-extrabold text-base whitespace-nowrap cursor-pointer hover:from-yellow-400 hover:to-orange-400 transition-all duration-300 shadow-xl shadow-yellow-500/25 hover:shadow-yellow-500/40 hover:scale-105"
          >
            <i className="ri-vip-crown-line text-lg" />
            Premium'a Geç
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to="/auth"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white/5 border border-white/10 text-white/60 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-white/10 hover:text-white transition-all backdrop-blur-sm"
          >
            Önce Ücretsiz Dene
          </Link>
        </div>

        {/* Guarantee badges */}
        <div className="flex flex-wrap items-center justify-center gap-4">
          {[
            { icon: 'ri-shield-check-line', label: '7 gün para iade garantisi' },
            { icon: 'ri-lock-line', label: 'Güvenli ödeme' },
            { icon: 'ri-close-circle-line', label: 'İstediğin zaman iptal' },
          ].map((badge) => (
            <div key={badge.label} className="flex items-center gap-2 text-white/30 text-xs">
              <i className={`${badge.icon} text-white/25`} />
              {badge.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PremiumFinalCTA;
